import { GlobalClassInstance } from "@commoncore/constants/GlobalClass";
import { TOAST } from "@commoncore/constants/ToastMessages";
import { LocalStorageProps } from "@commoncore/enums/localStorageProps";
import { FileOperationsImplementation } from "@commoncore/implementation/FileOperationsImplementation";
import { GlobalService } from "@commoncore/services/global.service";
import { AppEvents } from "@commoncore/utils/app-events";
import { ENV_CONSTANTS } from "@env-properties/environment";
import { ENV_CONFIG } from "@env-properties/environment-config";
import { IcloudBackupImpementation } from "../implementation/icloudBackupImpementation";
import { AllFilesController } from "./AllFilesController";
import { error } from "console";

export class IcloudBackupController {
    fileOperationsImplementation:any;
    public icloudImplRef: any;
    public universalService: any;
    public router: any;
    public http: any;
    public fetchFolderData: boolean = false;
    public static singleInstance: any = null;
    public listService: any;
    public sortOrder: any;
    loggerService: any;
    allfilesController:any;
    response: any;
    transferInitiated:boolean = false;
    localStorageSvc:any;
    transferStatus:any = [];
    private intervalId: any;
    allTrasferCompleted: boolean = false;
    private initalstatusInterval:any;
    activeAccordian:any;
   
    private fileStatusInterval:any;

    constructor(public globalService: GlobalService) {
        this.icloudImplRef = IcloudBackupImpementation.getInstance(this.globalService);
        this.fileOperationsImplementation = FileOperationsImplementation.getInstance(globalService);
        this.allfilesController=AllFilesController.getInstance(this.globalService);
    }

    public static getInstance(globalService): IcloudBackupController {
        if (this.singleInstance == null) {
        this.singleInstance = new IcloudBackupController(globalService);
        return this.singleInstance;
        } else {
        return this.singleInstance;
        }
    }

    public setEnvObjects(globalService) {
        this.universalService = globalService.getUniversalServiceRef();
        this.router = globalService.getRouterRef();
        this.http = globalService.getHttpClientRef();
        this.localStorageSvc = this.globalService.getLocalStorageSvcRef();
    }

    async getTransferSummery() {
      let self = this;
        var url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["sioURL"] + ENV_CONFIG["commonUrls"]["storageInteroperability"] + ENV_CONFIG["commonUrls"]["linkedAccounts"];
        try {
          self.icloudImplRef.setHandler(this.globalService);
          var res = await self.icloudImplRef.getTransferSummery(url);
          if(res){
            self.icloudImplRef.updateUIStatus(res)
            return Promise.resolve(res);
          }
        } catch (exc) {
          this.universalService.showToast(TOAST["GENERIC_ERROR"],"error");
          console.log("exception in getTransferSummery", exc);
          return Promise.resolve(null);
        }
    }

    async iClouAuth(id,password) {
        var url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["msgCallLogURL"] + ENV_CONFIG.commonUrls["iClouAuth"] ;
        try {
            this.icloudImplRef.setHandler(this.globalService);
            var res = await this.icloudImplRef.iClouAuth(url,id,password);
            if (res) {
                return res;
            }
        } catch (exc) {
            console.log("exception in iClouAuth", exc);
            return exc;
        }
    }

    async validate2FA(token){
        var url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["msgCallLogURL"] + ENV_CONFIG.commonUrls["icloudTokenValidation"];
        try {
            this.icloudImplRef.setHandler(this.globalService);
            var res = await this.icloudImplRef.validate2FA(url,token);
            this.universalService.showToast('Login successful. We are initiating the transfer.','success')
            if (res.status == 'success') {
                this.universalService.showLoader = false;
                this.initializeTransfer();
            } 
        } catch (exc) {
            console.log("exception in validate2FA", exc);
            return exc;
        }
    }

    async initializeTransfer(){
      var url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["msgCallLogURL"] + ENV_CONFIG.commonUrls["initializeTransfer"] ;
      try{
        var result
        result = await this.icloudImplRef.initializeTransfer(url);
        this.transferInitiated = true;
        clearInterval(this.intervalId);
        clearInterval(this.fileStatusInterval);
        this.getTransferSummery();
        this.getUpdatedTransferSummery();
        AppEvents.cloudBridgeObsevable.next({"openFirstAccordian":true});
        if(result){
          return result;
        }
      }catch(err){
        this.universalService.showToast(TOAST["GENERIC_ERROR"],"error");
      }
  }

  async getTransferStatus(id){
      var url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["msgCallLogURL"] + ENV_CONFIG.commonUrls["getIcloudBackupStatus"] + '?username=' + id ;
      try{
        var result
        result = await this.icloudImplRef.getTransferStatus(url);
        if(result){
          return result;
        }
      }catch(err){
        console.log("error in getTransferStatus",err);
        this.universalService.showLoader = false;
        this.universalService.showToast(TOAST["GENERIC_ERROR"],"error")
        // return null
      }
  }
  async getiCloudFailedFiles(transfer){
    var url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["sioURL"] + ENV_CONFIG["commonUrls"]["storageInteroperability"] + ENV_CONFIG["commonUrls"]["transferFailedFiles"] + "/" + transfer["storageType"] + "?email=" + transfer["sourceEmailId"];
      try{
        var result
        result = await this.icloudImplRef.getiCloudFailedFiles(url);
        if(result){
          return result;
        }
      }catch(err){
        console.log("error in getTransferStatus",err);
        return err;
      }
  }

  async getFileTransferStatus(transfer){
    var url = "";
    let self = this;
    if(transfer.storageType == 'GPHOTOS'){
      this.universalService.hideSizeColumn = true;
    }else{
      this.universalService.hideSizeColumn = false;
    }
    if(self.universalService.loadOnlyStatusPage){
      var cloudBridgeUserId = this.localStorageSvc.getLocalProperty(LocalStorageProps.STATUS_REQ_USER_ID, true);
      url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["sioURL"] + ENV_CONFIG.commonUrls["backupSnapshot"] + "/" +  "IPHOTOS" + "?email=" + cloudBridgeUserId["userAppleId"];
    } else {
      url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["sioURL"] + ENV_CONFIG.commonUrls["backupSnapshot"] + "/" +  transfer["storageType"] + "?email=" + transfer["sourceEmailId"];
    }
    try{
      var result
      result = await self.icloudImplRef.getFileTransferStatus(url);
      if(result){
        self.icloudImplRef.fileTransferStatus = result;
        await self.icloudImplRef.updateStatusUI(result,transfer);
        await self.icloudImplRef.updateStatusFileListUi();
        return Promise.resolve(result);
        // return result;
      }
    }catch(err){
      console.log("error in getTransferStatus",err);
      self.universalService.showLoader = false;
      self.universalService.showToast(TOAST["GENERIC_ERROR"],"error")
      // return null
    }
}

  async fetchDummyResponse(){
      try{
        var result
        result = await this.icloudImplRef.fetchDummyResponse();
        if(result){
          return result;
        }
      }catch(err){
        console.log("error in fetchDummyResponse",err);
        return null
      }
  }

  async getFolderMetadata(folderKey){
    var url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"] + ENV_CONFIG.commonUrls["nmsMetaData"] + "/" + folderKey + "/info";
    try{
      var result = await this.icloudImplRef.getFolderMetadata(url);
      return result;
    }catch(err){
      console.log("error in fetching folder metadata",err);
      return err;
    }
  }


  async getUpdatedTransferSummery(){
      let self = this;
      self.intervalId = null;
      self.intervalId = setInterval(async () => {
        var res = await self.getTransferSummery();
        if(res){
          await self.clearSummeryInterval();
          if(!self.universalService.inAppWebViewOpened){
            await self.icloudImplRef.updateUserStorage(res);
          }
          await self.icloudImplRef.updateUIStatus(res)
        }else{
          self.clearSummeryInterval();
        }
      },10000);//every 10 seconds
  }
  
  clearSummeryInterval(){
    let self = this;
    let index = self.icloudImplRef.transferList.findIndex(item => ['MI', 'MC', 'DI', 'DC', 'UI','I','R','AT','PS','MP','Q','W'].includes(item.backupStatus));
    if(index >= 0){
      return
    }else{
      clearInterval(self.intervalId);
      self.intervalId = null
    }
  }

  async getUpdatedStatuSummery(){
      let self = this;
      self.fileStatusInterval = null;
      self.fileStatusInterval = setInterval(async () => {
        let id = self.localStorageSvc.getLocalProperty(LocalStorageProps.STATUS_REQ_USER_ID,true);
        if(!id && !self.universalService.loadOnlyStatusPage){
          if(window.location.href.includes('ioscloudbridge')){
            self.router.navigate(['/ioscloudbridge']);
          }else{
            self.router.navigate(['/cloudbridge']);
          }
        }else if(!id && self.universalService.loadOnlyStatusPage){
            self.router.navigate(['/ioscloudbridge']);
        }
        
        var res = await self.getFileTransferStatus(id);
        if(res){
          await self.clearStatusInterval();

        }else{
          await self.clearStatusInterval();
          await self.localStorageSvc.removeLocalProperty(LocalStorageProps.STATUS_REQ_USER_ID); 
        }
      },5000); // every 5 sec
  }
  clearStatusInterval(){
    let self = this;
    if(self.icloudImplRef.fileTransferStatus?.backupStatus == 'UF' || self.icloudImplRef.fileTransferStatus?.backupStatus == 'DF'  || self.icloudImplRef.fileTransferStatus?.backupStatus == 'UC' || self.icloudImplRef.fileTransferStatus?.backupStatus == 'C' || self.icloudImplRef.fileTransferStatus?.backupStatus == 'QE' || self.icloudImplRef.fileTransferStatus?.backupStatus == 'U' || self.icloudImplRef.fileTransferStatus?.backupStatus == 'AF' || self.icloudImplRef.fileTransferStatus?.backupStatus == 'E' || self.icloudImplRef.fileTransferStatus?.backupStatus == 'F'){
      clearInterval(self.fileStatusInterval);
      self.fileStatusInterval = null;
    }
  }

  async startUserAccountBackup(authCode,storageProviderType){
    var url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["sioURL"] + ENV_CONFIG["commonUrls"]["storageInteroperability"] + ENV_CONFIG["commonUrls"]["registerUser"];
    try{
      this.icloudImplRef.setHandler(this.globalService);
      var result = await this.icloudImplRef.startUserAccountBackup(url,authCode,storageProviderType);
      return result;
    }catch(err){
      console.log("error in fetching linked accounts",err);
      return err;
    }
  }

  async registerUser(storageType){
    var url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["sioURL"] + ENV_CONFIG["commonUrls"]["storageInteroperability"] + ENV_CONFIG["commonUrls"]["sioAuthUrl"] + storageType;
    try{
      this.icloudImplRef.setHandler(this.globalService);
      var result = await this.icloudImplRef.registerUser(url,storageType);
      return result;
    }catch(err){
      console.log("error in fetching linked accounts",err);
    }
  }

  async pauseBackup(providerType,state){
    var url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["sioURL"] + ENV_CONFIG["commonUrls"]["storageInteroperability"] + ENV_CONFIG["commonUrls"]["pauseBackup"];
    try{
      this.icloudImplRef.setHandler(this.globalService);
      var result = await this.icloudImplRef.pauseBackup(url,providerType,state);
      return result;
    }catch(err){
      console.log("error in pausing linked accounts",err);
      return err;
    }
  }

  async disconnectBackup(backupDetails){
    var url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["sioURL"] + ENV_CONFIG["commonUrls"]["storageInteroperability"] + ENV_CONFIG["commonUrls"]["disconnectBackup"];
    try{
      this.icloudImplRef.setHandler(this.globalService);
      var result = await this.icloudImplRef.disconnectBackup(url,backupDetails);
      return result;
    }catch(err){
      console.log("error in diconnecting linked accounts",err);
      return err;
    }
  }

  async retryBackup(account){
    var url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["sioURL"] + ENV_CONFIG["commonUrls"]["storageInteroperability"] + ENV_CONFIG["commonUrls"]["retryBackup"];
    try{
      this.icloudImplRef.setHandler(this.globalService);
      var result = await this.icloudImplRef.retryBackup(url,account);
      return result;
    }catch(err){
      console.log("error in pausing linked accounts",err);
      return err;
    }
  }

  async resyncIcloudBackup(email){
    var url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["msgCallLogURL"] + ENV_CONFIG["commonUrls"]["resyncIcloudBackup"] + "?username=" + email;
    try{
      this.icloudImplRef.setHandler(this.globalService);
      var result = await this.icloudImplRef.resyncIcloudBackup(url);
      return result;
    }catch(err){
      console.log("error in pausing linked accounts",err);
      return err;
    }
  }
}
